export const actionTypes = {
  GET_USER_INFO: "GET_USER_INFO",
  SET_USER_INFO: "SET_USER_INFO",
  GET_COUNTRIES: "GET_COUNTRIES",
  SET_COUNTRIES: "SET_COUNTRIES",
  SET_COUNTRY_NAME: "SET_COUNTRY_NAME",
  SET_COUNTRY_SK: "SET_COUNTRY_SK",
  SET_COUNTRY_CHANGED: "SET_COUNTRY_CHANGED",
  SET_LOADING: "SET_LOADING",
  SET_REDIRECT: "SET_REDIRECT",
  CLEAR_FILTER: "CLEAR_FILTER",
  SET_ERROR: "SET_ERROR",
  SET_UPDATED: "SET_UPDATED",
  SET_ALERT: "SET_ALERT",
  GET_EZDS: "GET_EZDS",
  SET_EZDS: "SET_EZDS",
  SET_USER_AVAILABILITY: "SET_USER_AVAILABILITY",
  SET_COUNTRY_AVAILABILITY: "SET_COUNTRY_AVAILABILITY",
  SET_LOADER: "SET_LOADER",
  SET_ERROR_MESSAGE: "SET_ERROR_MESSAGE",
  HIDE_TOAST: "HIDE_TOAST",
};

export const actions = {
  getUserInfo: (payload) => ({
    type: actionTypes.GET_USER_INFO,
    payload: payload,
  }),

  setUserInfo: (payload) => ({
    type: actionTypes.SET_USER_INFO,
    payload: payload,
  }),

  setuserAvailability: (payload) => ({
    type: actionTypes.SET_USER_AVAILABILITY,
    payload: payload,
  }),

  setCountryAvailability: (payload) => ({
    type: actionTypes.SET_COUNTRY_AVAILABILITY,
    payload: payload,
  }),

  getCountries: (payload) => ({
    type: actionTypes.GET_COUNTRIES,
    payload: payload
  }),

  setCountries: (payload) => ({
    type: actionTypes.SET_COUNTRIES,
    payload: payload,
  }),

  setCountryName: (payload) => ({
    type: actionTypes.SET_COUNTRY_NAME,
    payload: payload,
  }),

  setLoader: (payload) => ({
    type: actionTypes.SET_LOADER,
    payload: payload,
  }),

  setCountrySk: (payload) => ({
    type: actionTypes.SET_COUNTRY_SK,
    payload: payload,
  }),

  setCountryChanged: (payload) => ({
    type: actionTypes.SET_COUNTRY_CHANGED,
    payload: payload,
  }),

  setLoading: (payload) => ({
    type: actionTypes.SET_LOADING,
    payload: payload,
  }),

  setRedirect: (payload) => ({
    type: actionTypes.SET_REDIRECT,
    payload: payload,
  }),

  setClearFilter: (payload) => ({
    type: actionTypes.CLEAR_FILTER,
    payload: payload,
  }),

  setError: (payload) => ({
    type: actionTypes.SET_ERROR,
    payload: payload,
  }),

  setErrorMessage: (payload) => ({
    type: actionTypes.SET_ERROR_MESSAGE,
    payload: payload,
  }),

  setUpdated: (payload) => ({
    type: actionTypes.SET_UPDATED,
    payload: payload,
  }),

  setAlert: (payload) => ({
    type: actionTypes.SET_ALERT,
    payload: payload,
  }),

  getEzds: (payload) => ({
    type: actionTypes.GET_EZDS,
    payload: payload,
  }),

  setEzds: (payload) => ({
    type: actionTypes.SET_EZDS,
    payload: payload,
  }),

  hideToast: () => ({
    type: actionTypes.HIDE_TOAST
  })
};
